import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import type { DeviceRecord } from "@somewear/api";
import { apiDeviceRecordUpdate } from "@somewear/device";
import { workspaceActions } from "@somewear/workspace";
import type { RootState } from "@web/app/rootReducer";

export interface IWorkspaceDevice {
	serial: string;
	userAccountId: string;
	model: DeviceRecord.ModelMap[keyof DeviceRecord.ModelMap];
}

const adapter = createEntityAdapter<IWorkspaceDevice, string>({
	selectId: (device) => device.serial,
});

const workspaceDevicesSlice = createSlice({
	name: "workspaceDevices",
	initialState: adapter.getInitialState(),
	reducers: {
		_() {}, // every slice needs at least one reducer of it's own
	},
	extraReducers: (builder) => {
		builder.addCase(workspaceActions.fetchDevices.fulfilled, (state, action) => {
			adapter.upsertMany(state, action.payload.data.devicesList);
		});
		builder.addCase(apiDeviceRecordUpdate, (state, action) => {
			// if the device belongs to the active workspace add it to the workspace device list
			if (action.payload.asset !== undefined) adapter.upsertOne(state, action.payload.record);
		});
	},
});

// Rename the exports for readability in component usage
export const { selectAll: selectAllWorkspaceDevices, selectById: selectWorkspaceDeviceBySerial } =
	adapter.getSelectors((state: RootState) => state.workspaceDevices);

export default workspaceDevicesSlice;
